import React from 'react';

const ScoringControls = ({ striker, bowler, totalBalls, onScore, isSubmitting }) => {
    const handleRunClick = (runs) => {
        const currentOver = Math.floor(totalBalls / 6);
        const currentBallInOver = (totalBalls % 6) + 1;

        onScore({
            batting_team_id: striker.game_team_id,
            bowling_team_id: bowler.game_team_id,
            inning_number: 1, // This should come from parent state
            over_number: currentOver,
            ball_number: currentBallInOver,
            batsman_id: striker.id,
            bowler_id: bowler.id,
            runs_scored: runs,
            is_wicket: false, // Wicket logic needs to be added
        });
    };
    
    // Wicket and Extra handlers would go here

    return (
        <footer className="scoring-controls">
            <div className="run-buttons">
                <button onClick={() => handleRunClick(0)} disabled={isSubmitting}>0</button>
                <button onClick={() => handleRunClick(1)} disabled={isSubmitting}>1</button>
                <button onClick={() => handleRunClick(2)} disabled={isSubmitting}>2</button>
                <button onClick={() => handleRunClick(3)} disabled={isSubmitting}>3</button>
                <button onClick={() => handleRunClick(4)} disabled={isSubmitting}>4</button>
                <button onClick={() => handleRunClick(6)} disabled={isSubmitting}>6</button>
            </div>
            <div className="extra-buttons">
                <button disabled={isSubmitting}>Wd</button>
                <button disabled={isSubmitting}>Nb</button>
                <button disabled={isSubmitting}>Bye</button>
                <button className="wicket-btn" disabled={isSubmitting}>WICKET</button>
            </div>
        </footer>
    );
};

export default ScoringControls;
